import { useState } from "react";
import { CardMedia, Skeleton, Box, useTheme } from "@mui/material";
import { useFetchVideoImage } from "../api/use-fetch-image";
import { useVideoContext } from "../../../entities/video/provider/video-context";
import { VideocamOff } from "@mui/icons-material";

export interface DeviceImageProps {
    title: string;
    videoId?: string;
}

export const DeviceImage: React.FC<DeviceImageProps> = (props) => {
    const { videoId } = props;
    const { data: imageData, isError: isImageError } =
        useFetchVideoImage(videoId);
    const [loadedVideoId, setLoadedVideoId] = useState<string | undefined>();
    const { isError: isVideoError } = useVideoContext();
    const theme = useTheme();

    const imageHeight = 200;

    const isImageLoaded = loadedVideoId === videoId && !!imageData;

    return (
        <>
            {(isVideoError || isImageError) && (
                <Box
                    aria-label="Video unavailable"
                    sx={{
                        height: imageHeight,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        bgcolor: theme.palette.action.hover,
                        color: theme.palette.text.secondary,
                    }}
                    data-testid="device-image-error"
                >
                    <VideocamOff fontSize="large" color="disabled" />
                </Box>
            )}
            {!isImageLoaded && !isVideoError && !isImageError && (
                <Skeleton
                    variant="rectangular"
                    height={imageHeight}
                    data-testid="device-image-skeleton"
                />
            )}
            <CardMedia
                component="img"
                sx={{
                    height: imageHeight,
                    objectFit: "contain",
                    backgroundColor: "black",
                }}
                image={imageData}
                title={props.title}
                style={{ display: isImageLoaded ? "block" : "none" }}
                onLoad={() => setLoadedVideoId(videoId)}
            />
        </>
    );
};
